import { EditableImg, EditableText } from '@smartfire/components'
import {
    ChildrenBlock,
    defineBlock,
    smartProps,
    useEditor,
    useInspectorControl,
} from '@smartfire/js-block-engine'
import clsx from 'clsx'
import React from 'react'
import HeartEdge from '../assets/home-don-heart-edge.png'
import Button from '../button/block'
import { ReactComponent as HeartIcon } from './heart-icon.svg'
import { ReactComponent as HeartLine } from './heart-line.svg'
import style from './block.module.scss'

const Inspector = React.lazy(() => import('./Inspector'))

const Block = ({ buttonText, buttonLink }) => {
    useInspectorControl(Inspector)
    const { isEditing } = useEditor()

    return (
        <div className={clsx(style.block, isEditing && style.admin)}>
            <img className={style.heartEdge} src={HeartEdge} alt="Fond de quart de coeur" />

            <div className={style.content}>
                <div className={style.imageContainer}>
                    <EditableImg className={style.editableImg} smartProp="image" />
                </div>

                <div className={style.rightSide}>
                    <div className={style.textContainer}>
                        <EditableText
                            className={style.title}
                            smartProp="title"
                            placeholder="Titre"
                        />

                        <EditableText
                            className={style.subtitle}
                            smartProp="subtitle"
                            placeholder="Sous-titre"
                        />

                        <ChildrenBlock
                            gutenbergEditorConfig={{
                                allowedBlocks: ['core/paragraph'],
                                template: [
                                    ['core/paragraph', { content: 'Insérez du texte ici...' }],
                                ],
                            }}
                        />

                        <Button
                            text={buttonText}
                            link={!isEditing ? buttonLink : undefined}
                            aspect="contained"
                            color={style.blue}
                            colorHover={style.lightBlue}
                            classNames={style.button}
                            icon={<HeartIcon />}
                            inspector={false}
                        />
                    </div>

                    <HeartLine className={style.bottomIcon} />
                </div>
            </div>

            <div className={style.background} />
        </div>
    )
}

export default defineBlock({
    Block,
    smartProps: {
        image: smartProps.image,
        title: smartProps.string.withDefault(''),
        subtitle: smartProps.string.withDefault(''),
        buttonText: smartProps.string.withDefault('Faire un don'),
        buttonLink: smartProps.string.withDefault('/'),
    },
    setup: {
        title: 'Home don',
    },
})
